import React, { useContext, useEffect, useState } from "react";

import { makeStyles, TextField } from "@material-ui/core";
import { createStyles, Theme } from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";

import { HospitalsContext } from "../RodaHomepage";
import { HospitalName } from "../types";
import { getHospitals } from "../../../api/hospital";
import { errorCodes } from "../../../constants/errors";
import { PublicHospitalsContext } from "../../PublicStatistics/PublicStatistics";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    autocomplete: {
      "& .MuiInputLabel-root": {
        fontWeight: "bold",
        color: "#000",
      },
      [theme.breakpoints.only("xs")]: {
        width: "100%",
      },
    },
    autocompletePublic: {
      width: "100%",
      margin: theme.spacing(3, 15, 0, 0),
    },
    option: {
      padding: theme.spacing(2),
      borderBottom: `1px solid ${theme.palette.secondary.dark}`,
      "&:hover": {
        backgroundColor: theme.palette.secondary.main,
        color: "#fff",
      },
    },
  })
);

type HospitalDropdownMenuProps = {
  isPublic?: boolean;
  setFieldValue?: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void;
  fieldName?: string;
  hospitalName?: string;
  setHospitalName?: (hospitalName: string) => void;
  isBirthPlan?: boolean;
};

export default function HospitalDropdownMenu({
  isPublic,
  setFieldValue,
  fieldName,
  hospitalName,
  setHospitalName,
  isBirthPlan = false,
}: HospitalDropdownMenuProps) {
  const classes = useStyles();
  const [hospitals, setHospitals] = useState<HospitalName[]>([]);

  const { setCurrentHospital, setError } = useContext(HospitalsContext);
  const { setCurrentPublicHospital } = useContext(PublicHospitalsContext);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await getHospitals();
        const allHospitals = response.data?.hospitalNameList || [];

        if (isBirthPlan) {
          const filtered = allHospitals.filter((hospital: HospitalName) => hospital.maternity);
          setHospitals(filtered);
        } else {
          setHospitals(allHospitals);
        }
      } catch (reason: any) {
        if (
          reason.response &&
          reason.response.status === errorCodes.NOT_FOUND
        ) {
          setError(true);
        } else {
          console.error("Failed to fetch hospitals:", reason);
          setHospitals([]);
        }
      }
    }

    fetchData();
  }, []);

  return (
    <Autocomplete
      id="hospital-box"
      options={hospitals}
      getOptionLabel={(hospital) => hospital.name}
      noOptionsText={"Nema podataka"}
      className={isPublic ? classes.autocompletePublic : classes.autocomplete}
      classes={{ option: classes.option }}
      onChange={(event, newValue) => {
        if (newValue) {
          if (isPublic) {
            setCurrentPublicHospital(newValue.id);
          } else {
            setCurrentHospital(newValue.id);
          }
          setFieldValue && fieldName && setFieldValue(fieldName, newValue.name);
          setHospitalName && setHospitalName(newValue.name);
        }
      }}
      style={
        (!setHospitalName &&
          !isPublic && { width: "42vw", marginBottom: 40 }) ||
        {}
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={isBirthPlan ? "Odaberite rodilište" : "Odaberite ustanovu:"}
          variant="outlined"
          style={{ fontWeight: "bold" }}
        />
      )}
    />
  );
}
